import {isNil, union} from 'ramda';

import {GetAllMakeModelsApiResponse, Make, ModelFamily} from '@dms/api/shared';

const mergeRecords = <T>(
  base: Record<string, T>,
  extra: Record<string, T>,
  merge: (baseValue: T, extraValue: T) => T
): Record<string, T> => {
  const merged = new Map(Object.entries(base));
  Object.entries(extra).forEach(([key, extraValue]) => {
    const baseValue = merged.get(key);
    merged.set(key, isNil(baseValue) ? extraValue : merge(baseValue, extraValue));
  });
  return Object.fromEntries(merged);
};

const mergeMake = (base: Make, extra: Make): Make => ({
  ...base,
  models: union(base.models, extra.models),
  modelFamilies: union(base.modelFamilies, extra.modelFamilies),
});

const mergeModelFamily = (base: ModelFamily, extra: ModelFamily): ModelFamily => ({
  ...base,
  models: union(base.models, extra.models),
});

/**
 * Merges two vehicle catalogues (passenger cars and vans) into one.
 *
 * Makes and model families present in both (Ford, VW Transporter, …) appear once with the models
 * of both catalogues; the labels of `base` win.
 */
export const mergeMakesModels = (
  base: GetAllMakeModelsApiResponse,
  extra: GetAllMakeModelsApiResponse
): GetAllMakeModelsApiResponse => ({
  makes: mergeRecords(base.makes, extra.makes, mergeMake),
  models: {...extra.models, ...base.models},
  modelFamilies: mergeRecords(base.modelFamilies, extra.modelFamilies, mergeModelFamily),
});
